module.exports = __webpack_public_path__ + "img/upload-icon.274b4845.svg";